// extracted by mini-css-extract-plugin
module.exports = {"upgradeLink":"PrivacyTooltip_upgradeLink__s9To_","tooltip":"PrivacyTooltip_tooltip__UnXEb"};